import 'imagesloaded';

export default function () {
    var herald_load_ajax_new_count = 0;
    $("body").on('click', '.herald-load-more a', function (e) {
        e.preventDefault();
        var $link = $(this);
        var page_url = $link.attr("href");
        var start_url = window.location.href;
        var prev_title = window.document.title;
        $link.addClass('herald-loader-active');
        $('.herald-loader').show();
        $("<div>").load(page_url, function () {
            var n = herald_load_ajax_new_count.toString();
            var $wrap = $link.closest('.herald-module').find('.herald-posts');
            var $new = $(this).find('.herald-module:last article').addClass('herald-new-' + n);
            var $this_div = $(this);
            imagesLoaded($new, function() {
                $new.hide().appendTo($wrap).fadeIn(400);
                if ($this_div.find('.herald-load-more').length) {
                    $('.herald-load-more').html($this_div.find('.herald-load-more').html());
                    $('.herald-loader').hide();
                    $link.removeClass('herald-loader-active');
                } else {
                    $('.herald-load-more').fadeOut('fast').remove();
                }
                herald_sticky_sidebar(true);
                if (page_url != window.location) {
                    herald_pushes_up++;
                    herald_pushes_down++;
                    var next_title = $this_div.find('title').text();
                    var push_obj = {
                        prev: start_url,
                        next: page_url,
                        offset: $(window).scrollTop(),
                        prev_title: prev_title,
                        next_title: next_title
                    };
                    herald_url_pushes.push(push_obj);
                    window.document.title = next_title;
                    window.history.pushState(push_obj, '', page_url);
                }
                herald_load_ajax_new_count++;
                return false;
            });
        });
    });
}
